<template>
    <div
        v-bind:class="{ 'd-block': hasValidationError }"
        class="invalid-feedback fw-bold">
        {{ validationError }}
    </div>
</template>

<script>
    export default {
        props: {
            hasValidationError: { type: Boolean, required: true },
            validationError: { type: String, required: false, default: null }
        }
    };
</script>
